import types from "../actions";

const initialState = {};
let newAdsList = {};
export default function (state = initialState, action) {
  switch (action.type) {
    case types.GET_ADS_LIST_SUCCESS:
      const ads = {};
      action.data.forEach(ad => {
        ads[ad.id] = ad;
      });
      return { ...state, list: ads };
    case types.GET_SINGLE_AD_SUCCESS:
      newAdsList = state.list || {};
      newAdsList[action.data.id] = action.data
      return {
        ...state,
        list: newAdsList
      }
    case types.SAVE_AD_SUCCESS:
      const adId = action.payload.initial.id || action.payload.res.data.identifier;
      return {
        ...state,
        list: { ...state.list, [adId]: { ...action.payload.initial, id: adId } }
      };
    case types.DELETE_AD_SUCCESS:
      newAdsList = state.list;
      delete newAdsList[action.data.id];
      return {
        ...state,
        list: newAdsList
      };
    default:
      return state;
  }
}
